import Phaser from 'phaser';
import { landscapeLayout } from '../../layout/tableLayout.js';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('CrapsBootScene');
  }

  preload() {
    // Felt placeholder — currently unused but kept for compatibility with
    // upstream code paths that may reference it.
    this.textures.generate('felt', { data: ['1'.repeat(8)], pixelWidth: 16 });

    // Both panels rasterize at the landscape-target size for crispness on
    // hi-DPI displays. Portrait re-uses the same rasterized textures (the
    // panels scale up/down at draw time).
    const layout = landscapeLayout(this.scale.width, this.scale.height);
    for (const panel of layout.panels) {
      const url =
        panel.svgKey === 'tableMain' ? '/craps-table-main.svg' : '/craps-table-hardway.svg';
      this.load.svg(panel.svgKey, url, {
        width: Math.round(panel.dst.w),
        height: Math.round(panel.dst.h),
      });
      const textKey = panel.svgKey === 'tableMain' ? 'tableMainSvgText' : 'tableHardwaySvgText';
      this.load.text(textKey, url);
    }
  }

  create() {
    this.scene.start('CrapsTableScene');
    this.scene.launch('CrapsUIScene');
    this.scene.launch('CrapsDiceOverlayScene');
  }
}
